//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useListableProperties } from '@/api/legacy/useListableProperties';
import VisualEditorRow from './FilterBuilder/VisualEditorRow.vue';
import { getStringVersion, getVisualVersion } from './FilterBuilder/helpers';

const getBaseRow = () => ({ left: null, op: '==', right: null });

export default {
  name: 'FilterBuilder',
  components: {
    VisualEditorRow,
  },
  props: {
    query: { type: String, default: null },
    disableTimeFilters: { type: Boolean, default: false },
    hideCalculatedProperties: { type: Boolean, default: false },
  },
  setup() {
    const { listableProperties } = useListableProperties();
    return { listableProperties };
  },
  data() {
    return {
      visualEditor: true,
      advancedEditor: false,
      copyEditor: false,
      operator: 'and',
      visualRows: [getBaseRow()],
      advancedQuery: null,
    };
  },
  computed: {
    stringVersion() {
      return getStringVersion(this.visualRows, this.operator);
    },
    visualEditorDisabled() {
      if (this.visualEditor || !this.advancedQuery) return false;
      const { error } = getVisualVersion(this.advancedQuery, this.listableProperties);
      return !!error;
    },
  },
  watch: {
    query: {
      immediate: true,
      handler(_, old) {
        if (!old || this.advancedEditor) {
          this.restoreQuery(this.query);
        }
      },
    },
  },
  methods: {
    reset() {
      this.visualEditor = true;
      this.operator = 'and';
      this.visualRows = [getBaseRow()];
      this.advancedQuery = null;
    },
    copyFromQuery(filter) {
      const { expression: query } = filter || {};
      if (!query) {
        this.reset();
      }
      this.copyEditor = false;
      this.visualEditor = true;
      this.restoreQuery(query);
      this.$refs.copySelector.clear();
    },
    toggleOperator() {
      this.operator = this.operator === 'and' ? 'or' : 'and';
      this.handleChange();
    },
    changeTab(tab) {
      const query = this.visualEditor ? this.stringVersion : this.advancedQuery;
      this.visualEditor = tab === 'visual';
      this.advancedEditor = tab === 'advanced';
      this.copyEditor = tab === 'copy';
      if (!this.copyEditor) {
        this.restoreQuery(query);
      }
    },
    addNewRow() {
      this.visualRows.push(getBaseRow());
    },
    removeRow(index) {
      this.visualRows.splice(index, 1);
      this.handleChange();
    },
    handleChange() {
      const query = this.visualEditor ? this.stringVersion : this.advancedQuery;
      this.$emit('filter-change', query);
    },
    restoreQuery(query) {
      if (query) {
        this.advancedQuery = query;

        if (this.visualEditor) {
          // FIXME: do in store.
          const { error, rows, operator } = getVisualVersion(query, this.listableProperties);
          if (error) {
            this.visualEditor = false;
            this.advancedEditor = true;
          } else {
            this.visualRows = rows;
            this.operator = operator;
          }
        }
      }
      this.handleChange();
    },
  },
};
